import { useState, useEffect } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from 'react-bootstrap/Navbar';
import { Container, NavLink, Nav, Button } from 'react-bootstrap';
import { NavDropdown } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { useNavigate } from 'react-router-dom'

import { Authentication, logout } from '../Utils/Authentication'

function NavigationBar( props )
{
    const [ loaded, setLoadded ] = useState( false )
    const [ authenticated, setAuthenticated ] = useState( false )
    const [ username, setUsername ] = useState( null )

    let auth = new Authentication()
    let navigate = useNavigate()

    useEffect( () => {
        auth.has_token().then( a => {
            setAuthenticated(a)
            setUsername( auth.username() )
            setLoadded( true )
        })
    }, [])

    const logoutFunc = () => {
        logout()
        navigate("/login")

    }

    return (
        <Navbar bg="dark" variant="dark" style={{ height:"60px", paddingLeft:"100px", paddingRight:"100px"}}>
            <Container>
                <Nav className="ml-auto"> 
                    <LinkContainer to="/">
                        <Navbar.Brand className="nav-item">
                            Clinic Manager
                        </Navbar.Brand>
                    </LinkContainer>
                    { authenticated &&
                    <>
                        <LinkContainer to="/departments">
                            <NavLink>Departments</NavLink>
                        </LinkContainer>
                        <LinkContainer to="/roles">
                            <NavLink>Roles</NavLink>
                        </LinkContainer>
                        <LinkContainer to="/staff">
                            <NavLink>Staff</NavLink>
                        </LinkContainer>
                        {/*<LinkContainer to="/rotations">
                            <NavLink>Rotations</NavLink>
                        </LinkContainer>*/}
                        <NavDropdown title="Applications" menuVariant="dark">
                            <LinkContainer to="/planner/rotations">
                                <NavLink>Rotation Planner</NavLink>
                            </LinkContainer>
                            <LinkContainer to="/planner/daily">
                                <NavLink>Daily Planner</NavLink>
                            </LinkContainer>
                        </NavDropdown>
                    </>
                    }
                </Nav>

                <Nav className="ms-auto">
                    { authenticated && 
                    <NavDropdown
                        title={username}
                        menuVariant="dark"
                    >
                        <NavDropdown.Item>
                            <NavLink onClick={ logoutFunc }>Logout</NavLink>
                        </NavDropdown.Item>
                    </NavDropdown>
                    }

                    { !authenticated &&
                    <LinkContainer to="/login">
                        <NavLink>Login</NavLink>
                    </LinkContainer>
                    }
                </Nav>
            </Container>
        </Navbar>
    )

}

export default NavigationBar;
